import { useState, useEffect } from 'react';

/**
 * Проверяет наличие интернет-соединения
 * @returns {boolean} true если есть интернет, false если нет
 */
export const checkInternetConnection = () => {
  if (typeof navigator !== 'undefined' && 'onLine' in navigator) {
    return navigator.onLine;
  }
  // Если navigator.onLine недоступен, считаем что интернет есть
  return true;
};

/**
 * Хук для отслеживания статуса интернет-соединения
 * @returns {boolean} true если есть интернет, false если нет
 */
export const useInternetStatus = () => {
  const [isOnline, setIsOnline] = useState(() => checkInternetConnection());

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    // Устанавливаем начальное значение
    setIsOnline(checkInternetConnection());

    // Добавляем слушатели событий
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Очистка слушателей при размонтировании
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
};

export default {
  checkInternetConnection,
  useInternetStatus,
};

